<template>
    <div class="classify-edit">
        <ul style="list-style-type:none">
            <li v-if="isEdit">
                <Icon type="ios-key" class="icon-style" />
                <title-text :inline="true" :onlyText="false">{{
                    curItemObj ? curItemObj.dataName : '-'
                }}</title-text>
                <div class="classify-block">
                    <div
                        v-for="(item, index) in initDataObj.FIELD_KIND"
                        :key="`${item.name}-${index}`"
                        @click="$set(item, 'checked', !item.checked)"
                        class="margin-tb-10 card-block margin-left-20 cursor-point"
                        :class="item.checked ? 'hot-block' : ''"
                    >
                        {{ item.name }}
                        <div v-if="item.checked" class="tip-group">
                            <div class="triangle">
                                <Icon
                                    type="md-checkmark"
                                    size="16"
                                    class="icon"
                                ></Icon>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li v-else>
                <Icon type="ios-key" class="icon-style" />
                <title-text :inline="true" :onlyText="false">{{
                    curItemObj ? curItemObj.dataName : '-'
                }}</title-text>
                <div v-if="selectData.fieldKind.length > 0">
                    <Tag
                        v-for="(item, index) in selectData.fieldKind"
                        :key="`${item.name}-${index}`"
                        color="blue"
                        class="tag margin-left-20 margin-tb-10"
                    >{{ item.name }}</Tag
                    >
                </div>
                <div v-else class="text-center" style="margin-top: 20%">
                    <img src="../../../../assets/no-data.svg" alt="" />
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'classify',
    props: ['selectData', 'isEdit', 'curItemObj', 'initDataObj'],
    watch: {
        isEdit: {
            handler() {
                if (this.isEdit) {
                    const choiceData = this.selectData.fieldKind.map((item) => item.id)
                    this.initDataObj.FIELD_KIND.forEach((item, index) => {
                        this.$set(this.initDataObj.FIELD_KIND[index], 'checked', choiceData.includes(item.id))
                    })
                }
            },
            deep: true
        }
    },
}
</script>
<style lang="less" scoped>
li::marker {
    content: '';
    display: none;
}
.tag {
    display: inline-block;
}
.margin-left-20 {
    margin-left: 20px;
}
.slider-com {
    width: 60%;
}
.card-block {
    border-radius: 4px;
    border: 1px solid var(--divider-color);
    padding: 10px;
    position: relative;
    width: 20%;
    display: inline-block;
}
.hot-block {
    border: 1px solid var(--comp-selected-color);
}
.tip-group {
    position: absolute;
    right: 0;
    bottom: -5px;
    .triangle {
        width: 0;
        height: 0;
        border-right: 36px solid var(--comp-selected-color);
        border-left: 10px solid transparent;
        border-top: 20px solid transparent;
        display: inline-block;
    }
    .icon {
        position: absolute;
        top: 4px;
        right: 0;
        bottom: 0;
        color: white;
    }
}
.icon-style {
    margin-right: 5px;
    font-size: 19px;
}
</style>
